export default __webpack_public_path__ + "static/media/gloves.ed40c9a3.jpg";